import gql from 'graphql-tag';

const GOOGLE_ADS_ACCESSIBLE_CUSTOMERS = gql`
  query googleAdsAccessibleCustomers($orgId: String!) {
    googleAdsAccessibleCustomers(orgId: $orgId)
  }
`;

export default GOOGLE_ADS_ACCESSIBLE_CUSTOMERS;
